
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireinbaner() {



    const cardData =
    {
        keyword: 'Bus Hire in Baner Pune ',
        heading: 'Amruta Travels: Bus Hire in Baner Pune',
        headingDescription: 'Amruta Travels offers Bus Hire in Baner, Pune, providing reliable and comfortable transportation solutions for various travel needs. Whether you are organizing a corporate event, wedding, school trip, or a family outing, our fleet includes a wide range of well-maintained buses, from 25-seater to 50-seater options, ensuring a smooth and enjoyable journey for all group sizes .',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


   "services": [
    {
      "name": "Bus Hire in Ravet",
      "description": "Amruta Travels offers reliable and comfortable bus hire services in Ravet, Pune. Ideal for families, school groups, or corporate teams, our buses come equipped with AC, pushback seating, and professional drivers. Whether you're planning a wedding, an outstation trip, or a daily shuttle service, we ensure timely and safe transportation with easy online booking options."
    },
    {
      "name": "Luxury Bus On Rent in Wakad",
      "description": "Experience luxury travel with Amruta Travels’ premium bus rentals in Wakad. Our luxury buses feature plush interiors, air conditioning, ample legroom, and entertainment systems. Ideal for VIP events, weddings, corporate conferences, and executive travel. Book online for a smooth and stylish group journey from Wakad and surrounding areas."
    },
    {
      "name": "Bus Hire in Hinjewadi Phase 1",
      "description": "Amruta Travels provides efficient and comfortable bus hire services in Hinjewadi Phase 1, Pune’s leading IT hub. Perfect for employee transport, team outings, or daily shuttles. Our fleet includes AC and non-AC options, with experienced drivers and punctual service designed for tech companies and corporate parks."
    },
    {
      "name": "Bus Hire in Hinjewadi Phase 2",
      "description": "Looking for group transport from Hinjewadi Phase 2? Amruta Travels offers bus hire services tailored to meet the needs of companies, schools, and families. From mini buses to 50+ seater coaches, enjoy clean interiors, well-maintained vehicles, and fast online booking for local or long-distance travel."
    },
    {
      "name": "Bus Hire in Hinjewadi Phase 3",
      "description": "Get dependable bus hire services in Hinjewadi Phase 3 with Amruta Travels. Our fleet serves corporate groups, educational institutions, and private bookings with AC comfort, on-time arrivals, and dedicated customer support. Ideal for commutes, trips, or special events."
    },
    {
      "name": "Bus On Rent in Tathawade",
      "description": "Rent a bus in Tathawade through Amruta Travels for stress-free group travel. Whether it's a college tour, wedding function, or team outing, we provide buses of all sizes, including luxury and mini options, backed by punctual service and professional drivers."
    },
    {
      "name": "Bus On Rent in Bavdhan",
      "description": "Amruta Travels offers bus rentals in Bavdhan for local and outstation trips. From school excursions to family functions and corporate tours, our services include AC/non-AC buses with spacious seating, cleanliness, and well-trained drivers to ensure a safe and comfortable ride."
    },
    {
      "name": "Bus Hire in Punawale",
      "description": "Hire a bus in Punawale with Amruta Travels for school outings, family functions, weddings, or business events. Our modern fleet includes everything from compact mini buses to 50+ seaters with air conditioning, reclining seats, and secure travel options."
    },
    {
      "name": "Luxury Bus On Rent in Rahatani",
      "description": "Amruta Travels brings you high-end, luxury bus rentals in Rahatani. Choose our premium buses for weddings, corporate events, or airport transfers. Our luxury fleet includes features like pushback seats, full AC, stylish interiors, and experienced chauffeurs for a superior group travel experience."
    },
    {
      "name": "Bus Hire in Ambegaon Narhe",
      "description": "Planning a trip from Ambegaon Narhe? Amruta Travels provides dependable bus hire services with a variety of vehicle sizes to suit all group types. Whether for religious trips, school functions, or business needs, enjoy safe and comfortable travel with our AC-equipped buses."
    },
    {
      "name": "Luxury Bus Hire in Baner Pune",
      "description": "For upscale travel needs in Baner, Pune, Amruta Travels offers luxury bus hire with modern amenities. Our top-tier buses come with AC, cushioned seats, ample luggage space, and sleek interiors. Perfect for executive groups, destination weddings, or outstation tours."
    },
    {
      "name": "Bus Hire in Model Colony",
      "description": "Amruta Travels offers convenient and affordable bus hire in Model Colony, Pune. Great for educational institutions, families, or businesses needing reliable group transportation. Buses include AC, comfortable seating, and are operated by professional drivers familiar with city routes."
    },
    {
      "name": "Bus Hire in Pashan Pune",
      "description": "Need a bus from Pashan? Amruta Travels offers flexible rental options with a fleet of clean, modern vehicles for all types of trips — be it college functions, office travel, or pilgrimages. Book online for fast confirmations and affordable rates."
    },
    {
      "name": "Bus Hire in Aundh",
      "description": "Hire buses in Aundh with Amruta Travels for seamless group travel. From mini buses to full-size luxury coaches, our fleet caters to weddings, school outings, and company offsites. Expect prompt service, AC comfort, and skilled drivers for a stress-free ride."
    },
    {
      "name": "35, 36, 40, 54, 55 Seater Bus Rental in Aundh",
      "description": "Amruta Travels offers large bus rentals (35 to 55 seaters) in Aundh for big group events, educational tours, religious trips, and corporate travel. Our well-maintained buses feature AC, reclining seats, and ample space to ensure a comfortable journey across any distance."
    },
    {
      "name": "Bus Hire in Wanwadi Pune",
      "description": "Get reliable bus hire services in Wanwadi, Pune with Amruta Travels. Perfect for school trips, private events, or business travel, we offer online booking for AC and non-AC buses with clean interiors and courteous drivers ensuring a smooth experience."
    }
  ],
  "tableData": [
    ["Bus Hire in Ravet", "Luxury Bus On Rent in Wakad"],
    ["Bus Hire in Hinjewadi Phase 1", "Bus Hire in Hinjewadi Phase 2"],
    ["Bus Hire in Hinjewadi Phase 3", "Bus On Rent in Tathawade"],
    ["Bus On Rent in Bavdhan", "Bus Hire in Punawale"],
    ["Luxury Bus On Rent in Rahatani", "Bus Hire in Ambegaon Narhe"],
    ["Luxury Bus Hire in Baner Pune", "Bus Hire in Model Colony"],
    ["Bus Hire in Pashan Pune", "Bus Hire in Aundh"],
    ["35, 36, 40, 54, 55 Seater Bus Rental in Aundh", "Bus Hire in Wanwadi Pune"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Reliable Bus Hire Services in Baner, Pune",
    "WhyChoosedescription": "Amruta Travels offers trusted and efficient bus hire services in Baner, Pune, catering to all your travel needs. Whether it’s a corporate transfer, family function, group tour, or outstation trip, our buses ensure a comfortable and dependable travel experience from Baner to any destination."
  },
  {
    "WhyChooseheading": "Wide Range of Buses to Suit Your Requirements",
    "WhyChoosedescription": "Choose from a variety of buses including luxury coaches, minibuses, and AC/non-AC buses depending on your group size and preferences. Our fleet is well-maintained and ideal for events, airport transfers, school outings, and long-distance travel starting from Baner."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Baner and Pune Routes",
    "WhyChoosedescription": "Our professional drivers have excellent knowledge of Baner and the surrounding areas, ensuring timely pickups and drop-offs. They are trained in safe driving practices and customer service, making your travel experience secure and pleasant."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing in Baner",
    "WhyChoosedescription": "We offer competitive and transparent pricing for all bus hire services in Baner, Pune. Our rates include fuel, tolls, driver fees, and taxes—there are no hidden costs. Get value for money while enjoying a premium travel experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Wedding, and Group Travel",
    "WhyChoosedescription": "Whether you’re organizing a wedding, corporate event, or group outing from Baner, our buses offer spacious seating, modern amenities, and a smooth ride. We cater to both short local trips and long-distance journeys with equal efficiency."
  },
  {
    "WhyChooseheading": "Quick and Easy Online Booking from Baner",
    "WhyChoosedescription": "Booking a bus from Baner is easy with Amruta Travels. Use our online platform or call us to schedule your ride. Our booking system is simple, efficient, and designed to save you time while providing full flexibility for changes or custom plans."
  },
  {
    "WhyChooseheading": "Luxurious Amenities for Maximum Comfort",
    "WhyChoosedescription": "Enjoy high-end features such as air conditioning, push-back seats, entertainment systems, and ample luggage space. Our buses are equipped to provide a relaxed, fatigue-free travel experience whether you're traveling within Pune or to an outstation destination."
  },
  {
    "WhyChooseheading": "24/7 Support and Local Assistance in Baner",
    "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist Baner residents with bookings, route planning, and last-minute changes. We ensure responsive and helpful service to make your travel stress-free."
  }
]


















    }

const faqData = [
  {
    question: 'Can I hire a bus in Baner, Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels provides bus hire services in Baner, Pune. Whether you need transportation for local travel or an outstation trip, our Bharatbenz buses are available for comfortable and reliable journeys.',
  },
  {
    question: 'What types of buses are available for hire in Baner, Pune?',
    answer: 'We offer a range of Bharatbenz buses with seating capacities of 32, 35, 40, and 50 seats. These buses are ideal for corporate events, weddings, school trips, and group tours starting from Baner or nearby areas.',
  },
  {
    question: 'Do you offer bus hire for outstation trips from Baner?',
    answer: 'Yes, Amruta Travels offers bus hire services from Baner for outstation destinations like Shirdi, Mahabaleshwar, Goa, Lonavala, and more. Our services include professional drivers and well-maintained buses.',
  },
  {
    question: 'Is driver service included in the bus hire from Baner?',
    answer: 'Yes, all our bus hire packages include experienced and licensed drivers who ensure a safe and hassle-free travel experience for your group.',
  },
  {
    question: 'How much does it cost to hire a bus from Baner, Pune?',
    answer: 'Pricing depends on factors like the type of bus, trip duration, distance, and specific requirements. Contact us with your travel details to receive a customized quote.',
  },
  {
    question: 'Are the buses hired from Baner well-maintained and sanitized?',
    answer: 'Yes, all our buses undergo regular maintenance and are thoroughly sanitized before each journey to ensure safety, hygiene, and comfort.',
  },
  {
    question: 'Can I book a bus online for hire in Baner?',
    answer: 'Absolutely! You can conveniently book a bus online through our website. Just provide your travel details, and our team will assist with confirmation and coordination.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rohan Jagtap',
    role: 'Marketing Executive, Baner',
    text: 'We hired a Bharatbenz bus from Baner for an office outing, and the entire experience was smooth. The bus was in excellent condition, and the driver was punctual and professional. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Naina Gokhale',
    role: 'Wedding Planner, Baner',
    text: 'Amruta Travels provided a spacious and clean Bharatbenz bus for our wedding guests in Baner. The service was outstanding and everything went as planned. Will definitely use their services again.',
    rating: 5,
  },
];









































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Baner Pune",
  "image": "https://bushireinpune.com/assets/images/bus-hire-in-baner-pune.jpg", // Update with the actual image URL
  "description": "Amruta Travels offers premium bus hire services in Baner, Pune. Choose from a variety of buses including 35, 36, 40, 54, 55-seater buses for corporate events, school trips, family outings, and more. Luxury buses, AC and Non-AC buses available for rent in Baner, Wakad, Hinjewadi, Bavdhan, and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499", // Adjust the price as per service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-in-baner-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Bus Hire in Baner Pune | Luxury & AC Bus Rentals | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent a luxury bus in Baner, Pune. Choose from 35, 36, 40, 54, 55-seater buses for corporate events, picnics, school trips, and more. Affordable and reliable bus hire services by Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireinbaner;